import React, { type FC } from "react";
import classes from "./DragCardsTitle.module.css";

type genreData = {
  genreData: {
    name: string;
    id: number;
  };
  navigatePath: string;
};

type DragCardsTitleProps = {
  switchActive?: boolean;
  onMovieClick?: () => void;
  onSeriesClick?: () => void;
  onArrowClick?: any;
  title: string;
  hideFilter?: boolean;
};

const DragCardsTitle: FC<DragCardsTitleProps> = ({
  switchActive,
  onMovieClick,
  onSeriesClick,
  onArrowClick,
  title,
  hideFilter,
}) => {
  return (
    <div className={classes.title_container}>
      <div className={classes.title_sub_container}>
        <p className={classes.title}>{title}</p>
        {!hideFilter && (
          <button className={classes.switch} type="button" >
            <div
              className={`${classes.switch_card} ${
                switchActive && classes.active
              }`}
              onClick={onMovieClick}
            >
              <p>Movies</p>
            </div>
            <div
              className={`${classes.switch_card_2} ${
                !switchActive && classes.active
              }`}
              onClick={onSeriesClick}
            >
              <p>Series</p>
            </div>
          </button>
        )}
      </div>
      {title.includes("Free") ? null : !title.includes("Trending") ? (
        <button type="button" className={classes.view} onClick={onArrowClick}>
          <i className={`pi pi-chevron-right ${classes.icon}`} />
        </button>
      ) : null}
    </div>
  );
};

export default DragCardsTitle;
